import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';

import Modal from '../../../components/Modal/Modal';
import Input from '../../../components/Input/Input';
import ConfirmModal from '../../../components/ConfirmModal/ConfirmModal';
import { IconCross } from '../../../assets/icon';
import postArticlesTheme, { clearPostThemeData } from '../../../thunks/articles/postArticlesTheme';

const inputClassName = 'py-[11px] px-[13px] font-normal text-[13px]';

const CreateArticlesThemeModal = ({ visible, toggleVisible }) => {
  const dispatch = useDispatch();
  const [newTheme, setNewTheme] = useState('');
  const [confirmModal, setConfirmModal] = useState(false);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const { createLoading, createError, createData } = useSelector((state) => ({
    createLoading: state?.postArticlesTheme.loading,
    createError: state?.postArticlesTheme.error,
    createData: state?.postArticlesTheme.data
  }), shallowEqual);

  useEffect(() => {
    if (createError) {
      enqueueSnackbar(createError, {
        variant: 'error',
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'center',
        },
        persist: true,
        action: (id) => (
          <div role="presentation" onClick={() => closeSnackbar(id)}>
            <IconCross />
          </div>
        )
      });
    }
    if (createData) {
      enqueueSnackbar('Theme create successfully', { variant: 'success' });
      toggleVisible();
      dispatch(clearPostThemeData());
    }
  }, [createError, createData]);

  const onCreate = () => {
    dispatch(postArticlesTheme({ article_theme_name: newTheme.trim() }));
    setConfirmModal(false);
  };

  return (
    <Modal
      visible={visible}
      toggleVisible={toggleVisible}
      title="Create new article theme"
      saveText="Create"
      canSave={(newTheme.length < 3 || createLoading)}
      hideCloseBtn
      onSave={() => setConfirmModal(true)}
    >
      <div>
        <Input
          name="themeName"
          placeholder="Type theme"
          value={newTheme}
          inputStyle={inputClassName}
          onChange={({ target: { value } }) => setNewTheme(value)}
        />
      </div>
      <ConfirmModal
        toggleVisible={() => setConfirmModal(false)}
        visible={confirmModal}
        onConfirm={onCreate}
        confirmText="Create new article type?"
      />
    </Modal>
  );
};

CreateArticlesThemeModal.propTypes = {
  visible: PropTypes.bool,
  toggleVisible: PropTypes.func
};

CreateArticlesThemeModal.defaultProps = {
  visible: false,
  toggleVisible: () => {}
};

export default CreateArticlesThemeModal;
